"use client";

import { useEffect } from "react";

// Корневой layout рендерит <html lang="en">; на /ru выставляем lang="ru".
export function RuLang() {
  useEffect(() => {
    document.documentElement.lang = "ru";
    return () => {
      document.documentElement.lang = "en";
    };
  }, []);
  return null;
}
